import React from 'react';
import { ShieldCheck, Zap, DollarSign } from 'lucide-react';
export function WhyDronesSection() {
  const valueProps = [{
    title: 'Unmatched Safety',
    description: 'No ladders, scaffolding, or lifts. Our drones eliminate fall risks for the crew and liability for your property.',
    icon: ShieldCheck
  }, {
    title: '5X Faster Turnaround',
    description: 'Drones cover large areas quickly — completing jobs in hours, not days, with minimal disruption to your business.',
    icon: Zap
  }, {
    title: 'Significant Cost Savings',
    description: 'No equipment rentals, reduced labor, and less water and chemical usage. Better results at a lower cost.',
    icon: DollarSign
  }];
  return <section className="bg-white py-20 lg:py-28 font-heading" data-id="element-198">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-200">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B3A5C] mb-4 uppercase tracking-tight" data-id="element-201">
            Why Drone-Powered Cleaning?
          </h2>
          <p className="text-lg text-[#1E1E1E]/80" data-id="element-202">
            Advanced technology that's safer, faster, and more cost-effective
            than traditional methods.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-203">
          {valueProps.map((prop, index) => {
          const Icon = prop.icon;
          return <div key={index} className="bg-[#F5F7FA] rounded-xl p-8 transition-all duration-300 hover:shadow-lg border-l-4 border-transparent hover:border-[#1B3A5C] group flex flex-col items-start" data-id="element-204">
                <div className="bg-white p-4 rounded-full shadow-sm mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-205">
                  <Icon className="w-8 h-8 text-[#1B3A5C]" data-id="element-206" />
                </div>
                <h3 className="text-xl font-bold text-[#1B3A5C] mb-3" data-id="element-207">
                  {prop.title}
                </h3>
                <p className="text-[#1E1E1E] leading-relaxed" data-id="element-208">
                  {prop.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}